const homeMixin = {
  methods: {
    trackLinkClick(evtName, evtData = {}) {
        this.$sendEvent(evtName, evtData)
    }
  }
}
export default homeMixin
